/**
 * AWARE Health — i18n Configuration
 * Uses i18next with browser language detection.
 * Falls back to English. Stores preference in localStorage.
 */

import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import vi from './locales/vi.json'
import zhTW from './locales/zh-TW.json'
import ne from './locales/ne.json'

export const SUPPORTED_LANGUAGES = ['en', 'vi', 'zh-TW', 'ne'] as const

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en:      { translation: en },
      vi:      { translation: vi },
      'zh-TW': { translation: zhTW },
      ne:      { translation: ne },
    },
    supportedLngs: [...SUPPORTED_LANGUAGES],
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'aware-language',
    },
  })

// Keep <html lang> in sync for screen readers and correct font shaping
function syncHtmlLang(lng: string | undefined) {
  if (lng) document.documentElement.lang = lng
}
syncHtmlLang(i18n.resolvedLanguage)
i18n.on('languageChanged', syncHtmlLang)

export default i18n
